import LiveClassFeedbackDao from '../dao/live-class-feedback.dao';
import type { Environment } from '../interfaces/environment';

export abstract class LiveClassFeedbackService {
  static async getLiveClassFeedbacks(
    env: Environment,
    studentContactId?: string
  ) {
    return !studentContactId
      ? Promise.reject(new Error('Invalid id'))
      : await LiveClassFeedbackDao.getLiveClassFeedbacks(env, studentContactId);
  }

  static async getLiveClassFeedbackByUUID(
    env: Environment,
    feedbackUUID?: string
  ) {
    return !feedbackUUID
      ? Promise.reject(new Error('Invalid feedback uuid'))
      : LiveClassFeedbackDao.getLiveClassFeedbackByUUID(env, feedbackUUID);
  }
}
